import React from "react";
import dynamic from 'next/dynamic'
const Carousel = dynamic(() => import('react-multi-carousel'), { 
  ssr: false 
})
import { urlForImage } from '~/lib/sanity.image';
import RightArrowBottom from "./RightArrowBottom";
import LeftArrowBottom from "./LeftArrowBottom";
import Image from "next/image";
import "react-multi-carousel/lib/styles.css";


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 375 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const prefix = "/inspiration/"

const SilderSingle = ({items}) => {
  return (
    <div className="parent">        
      <Carousel
        responsive={responsive}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}  
        customLeftArrow={<LeftArrowBottom/>}
        customRightArrow={<RightArrowBottom />}  
        containerClass="spacer-carousel-container"
        dotListClass="spacer-custom-dot-list-style"    
      >
        {items.length && (
          items.map((item, index) => {
            const firstImage = item.mainCarousel[0]
  
            return (
              <div className="slider" key={index}>
                <div className="imageWrapper">
                {firstImage && (
                      <Image
                        key={firstImage._id}
                        src={urlForImage(firstImage).url()}
                        alt={firstImage.title ? firstImage.title : 'slider'}
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }} 
                        className="h-full w-full object-cover"
                      />
                    )}
                </div>
                  <h3 className="text-2xl font-semibold text-primary mt-10 mb-5">{item.title}</h3>
                  <div className="flex">
                    <div className="grow">                  
                      <p className="text-xl text-primary">{item.excerpt}</p>
                    </div>
                    <div className="flex-none w-20 flex items-end justify-end">
                      <a className="mt-2 font-bold underline" href={prefix + item.slug.current}>More</a>
                    </div>
                  </div>      
              </div>
            );
          })
        )}        
      </Carousel>
    </div>
  );
};
export default SilderSingle;
